import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ContentCash icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ContentCash } from '@sravni/design-system-icons'
 *
 * <ContentCash />
 * ```
 */
var ContentCash = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ContentCash", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.069 7.292c-.576 0-1.042.466-1.042 1.042v8.333c0 .576.466 1.042 1.042 1.042h13.333c.576 0 1.042-.466 1.042-1.042V8.334c0-.576-.466-1.042-1.042-1.042H4.07ZM1.777 8.334A2.291 2.291 0 0 1 4.07 6.042h13.333a2.291 2.291 0 0 1 2.292 2.292v8.333a2.291 2.291 0 0 1-2.292 2.292H4.07a2.291 2.291 0 0 1-2.292-2.292V8.334Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.767 11.47a1.458 1.458 0 0 0-2.063 0l-.441-.443.441.442c-.569.57-.569 1.493 0 2.063l-.441.441.441-.442a1.458 1.458 0 0 0 2.063-2.062l.442-.442-.442.442Zm-2.946-.885a2.708 2.708 0 1 1 3.83 3.83 2.708 2.708 0 0 1-3.83-3.83ZM15.736 9.792c.345 0 .625.28.625.625v4.167a.625.625 0 0 1-1.25 0v-4.167c0-.345.28-.625.625-.625ZM5.736 9.792c.346 0 .625.28.625.625v4.167a.625.625 0 0 1-1.25 0v-4.167c0-.345.28-.625.625-.625ZM3.443 4.167c0-.345.28-.625.625-.625h13.334a.625.625 0 1 1 0 1.25H4.068a.625.625 0 0 1-.625-.625ZM4.277 1.667c0-.345.28-.625.625-.625H16.57a.625.625 0 1 1 0 1.25H4.902a.625.625 0 0 1-.625-.625Z", fill: "currentColor" }))); });

export { ContentCash };
//# sourceMappingURL=ContentCash.js.map
